import {
  create_customer_type,
  update_customer_type,
  query_customer_type_list,
  delete_customer_type,
  recover_customer_type,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-customertype-config';

import { reactive } from 'vue';
import {get_is_active, get_is_active2} from "@/utils/function";

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY);

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '客户类型',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写客户类型',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    date: null,
    shop_id: null,
  }),
};
const search_options = {};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 7,
    },
    wrapperCol: {
      span: 17,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '客户类型',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写客户类型',
    },
    {
      type: 'number',
      name: 'price_down',
      label: '累计充值下限',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写累计充值下限',
    },
    {
      type: 'radio',
      name: 'price_down_equal',
      label: '下限是否包含等于',
      disabled: false,
      allowClear: true,
      labelKey: 'name',
      valueKey: 'value',
      defaultValue: '',
      placeholder: '请选择下限是否包含等于',
    },
    {
      type: 'number',
      name: 'price_up',
      label: '累计充值上限',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写累计充值上限',
    },
    {
      type: 'radio',
      name: 'price_up_equal',
      label: '下限是否包含等于',
      disabled: false,
      allowClear: true,
      labelKey: 'name',
      valueKey: 'value',
      defaultValue: '',
      placeholder: '请选择下限是否包含等于',
    },
    {
      type: 'number',
      name: 'duration_days',
      label: '达标后持续时间（天）',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写达标后持续时间（天）',
    },
    {
      type: 'number',
      name: 'index',
      label: '排序',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写排序',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    name: null,
    price_down: null,
    price_down_equal: false,
    price_up: null,
    price_up_equal: false,
    duration_days: null,
  }),
};
const edit_model_config_options = {
  price_down_equal: [
    { value: true, name: '是' },
    { value: false, name: '否' },
  ],
  price_up_equal: [
    { value: true, name: '是' },
    { value: false, name: '否' },
  ],
};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 7,
    },
    wrapperCol: {
      span: 17,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '客户类型',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写客户类型',
    },
    {
      type: 'number',
      name: 'price_down',
      label: '累计充值下限',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写累计充值下限',
    },
    {
      type: 'radio',
      name: 'price_down_equal',
      label: '下限是否包含等于',
      disabled: false,
      allowClear: true,
      labelKey: 'name',
      valueKey: 'value',
      defaultValue: '',
      placeholder: '请选择下限是否包含等于',
    },
    {
      type: 'number',
      name: 'price_up',
      label: '累计充值上限',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写累计充值上限',
    },
    {
      type: 'radio',
      name: 'price_up_equal',
      label: '下限是否包含等于',
      disabled: false,
      allowClear: true,
      labelKey: 'name',
      valueKey: 'value',
      defaultValue: '',
      placeholder: '请选择下限是否包含等于',
    },
    {
      type: 'number',
      name: 'duration_days',
      label: '达标后持续时间（天）',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写达标后持续时间（天）',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    name: null,
    price_down: null,
    price_down_equal: false,
    price_up: null,
    price_up_equal: false,
    duration_days: null,
  }),
};
const update_model_config_options = {
  price_down_equal: [
    { value: true, name: '是' },
    { value: false, name: '否' },
  ],
  price_up_equal: [
    { value: true, name: '是' },
    { value: false, name: '否' },
  ],
};

const titleList = {
  title: '客户类型',
  addModalTitle: '新建客户类型',
  updateTitle: '编辑客户类型',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    customer_type_id: 'id',
  },
  delete: {
    customer_type_id: 'id',
  },
  recover: {
    customer_type_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    customer_type_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 100,
  },
  {
    title: '客户类型',
    dataIndex: 'name',
    width: 100,
  },
  {
    title: '累计充值金额',
    width: 120,
    dataIndex: 'je',
    checked: true,
    content: (record: any, text: any) => {
      let value = '';
      if (record.price_down && record.price_up) {
        value = `${record.price_down}-${record.price_up}`;
      } else if (!record.price_down && record.price_up) {
        if (record.price_down_equal) {
          value = `小于等于${record.price_up}`;
        } else {
          value = `小于${record.price_up}`;
        }
      } else if (record.price_down && !record.price_up) {
        if (record.price_up_equal) {
          value = `大于等于${record.price_down}`;
        } else {
          value = `大于${record.price_down}`;
        }
      }
      return value;
    },
  },
  {
    title: '达标后持续时间（天）',
    width: 120,
    dataIndex: 'duration_days',
    checked: true,
    content: (record: any, text: any) => {
      return text == 0 ? '-' : text;
    },
  },
  {
    title: '操作',
    width: 80,
    dataIndex: 'action',
    checked: true,
    slots: { customRender: 'action' },
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
// newSlotList.push({
//   type: 'custom',
//   // slotName: 'is_active',
//   field_true: '可用',
//   field_false: '作废',
// });

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_customer_type_list,
    addData: create_customer_type,
    updateData: update_customer_type,
    removeData: delete_customer_type,
    recoverData: recover_customer_type,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
